import { Stack, Typography } from "@mui/material";
import AssetIcon from "../../../../Components/Misc/AssetIcon/asset-icon";
import { timespanToSec } from "./kpi-workflow";
import { useTranslation } from "react-i18next";

var moment = require("moment");
require("moment-duration-format");

const KpiTooltip = (props) => {
  const { t } = useTranslation();
  const { itemData, series } = props;
  const index = parseInt(itemData.dataIndex);

  const averageDelayTime = series.averageDelayTime[index] ?? "00:00:00";
  const averageTaskTime = series.averageTaskTime[index] ?? "00:00:00";
  const spendTimeTotal = series.spentTimeTotal[index] ?? "00:00:00";
  const date = series.currentDate[index] ?? "N/A";
  const count: number = series.data[index] ?? 0;

  return (
    <Stack
      alignContent={"center"}
      alignItems={"center"}
      justifyContent={"center"}
      width={"275px"}
      pl={1.5}
      pr={1.5}
      pt={0.3}
      pb={0.3}
      flexDirection={"column"}
      sx={(theme) => ({
        background: theme.palette.mode === "dark" ? theme.palette.background[200] : theme.palette.background.default,
        borderRadius: 1,
      })}
    >
      <Stack
        alignContent={"center"}
        alignItems={"center"}
        height={"35px"}
        width={"100%"}
        justifyContent={"space-between"}
        flexDirection={"row"}
      >
        <Stack alignContent={"center"} alignItems={"center"} height={"35px"} flexDirection={"row"}>
          <AssetIcon sx={{ mr: 0.5 }} colored type={series.label} />
          <Typography
            sx={(theme) => ({
              borderRadius: "100%",
              pt: 0.5,
              pb: 0.5,
              pl: count < 10 ? 1 : 0.7,
              pr: count < 10 ? 1 : 0.7,
              backgroundColor: theme.palette.backgroundAlpha.hover,
            })}
            variant="h6"
          >
            {count}
          </Typography>
        </Stack>

        <Typography lineHeight={"35px"} variant="h6">
          {date}
        </Typography>

        <Typography textAlign={"right"} lineHeight={"35px"} variant="h6">
          {series.label}
        </Typography>
      </Stack>
      <Stack
        alignContent={"center"}
        alignItems={"center"}
        height={"25px"}
        width={"100%"}
        justifyContent={"space-between"}
        flexDirection={"row"}
      >
        <Typography color="text.tier" variant="body2">
          {t("page:body.averageDelayTime")}
        </Typography>
        <Typography textAlign={"right"} variant="body2">
          {moment.duration(timespanToSec(averageDelayTime), "seconds").format()}
        </Typography>
      </Stack>
      <Stack
        alignContent={"center"}
        alignItems={"center"}
        height={"25px"}
        width={"100%"}
        justifyContent={"space-between"}
        flexDirection={"row"}
      >
        <Typography color="text.tier" variant="body2">
          {t("page:body.averageTaskTime")}
        </Typography>
        <Typography textAlign={"right"} variant="body2">
          {moment.duration(timespanToSec(averageTaskTime), "seconds").format()}
        </Typography>
      </Stack>
      <Stack
        alignContent={"center"}
        alignItems={"center"}
        height={"25px"}
        width={"100%"}
        justifyContent={"space-between"}
        flexDirection={"row"}
        mb={0.7}
      >
        <Typography color="text.tier" variant="body2">
          {t("page:body.totalTimeSpent")}
        </Typography>
        <Typography textAlign={"right"} variant="body2">
          {moment.duration(timespanToSec(spendTimeTotal), "seconds").format()}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default KpiTooltip;
